// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileAvatar_avatar__Ce0HN","avatarDefault":"ProfileAvatar_avatarDefault__S+EZm"};